import { httpClient, unwrap } from './httpClient';

export async function searchUsers(keyword, limit = 20) {
  if (!keyword) return [];
  const response = await httpClient.get('/admin/users/search', {
    params: { keyword, limit },
  });
  return unwrap(response) ?? [];
}

export async function listUsers({ search, sortBy, sortDir, page, pageSize }) {
  const response = await httpClient.get('/admin/users/', {
    params: {
      search: search || undefined,
      sort_by: sortBy,
      sort_dir: sortDir,
      page,
      page_size: pageSize,
    },
  });
  return unwrap(response);
}

const adminUserService = {
  searchUsers,
  listUsers,
};

export default adminUserService;
